import { z } from "zod";

const videoItemSchema = z.object({
  id: z.string(),
  url: z.string(),
  title: z.string(),
  description: z.string(),
  // thumbnail: z.string (),
});

export const formSchema = z.object({
  // Basic Info
  dgr: z
    .string()
    .min(1, "DGR is required")
    .transform((val) => val ?? "not provided")
    .optional(),

  birthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided")
    .optional(),

  sex: z
    .string()
    .min(1, "Sex is required")
    .transform((val) => val ?? "not provided")
    .optional(),

  name: z
    .string()
    .min(1, "Name is required")
    .transform((val) => val ?? "not provided")
    .optional(),

  age: z.number().optional(),
  breed: z.string().optional(),
  bullType: z
    .string()
    .min(1, "Bull Type required")
    .transform((val) => val ?? "not provided")
    .optional(),
  adg: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided")
    .optional(),

  animalType: z.string().optional(),

  milkKg: z.number().optional(),

  age1P: z.number().optional(),

  ebi: z.number().optional(),

  milkAcc: z.number().optional(),

  age1pAcc: z.number().optional(),
  ebiAcc: z.number().optional(),

  betaLac: z.string().min(0, "Beta-lactoglobulin must be positive").optional(),
  kappaC: z.string().min(0, "Kappa-casein must be positive").optional(),
  betaC: z.string().min(0, "Beta-casein must be positive").optional(),
  // Physical Attributes
  // w120: z
  //   .number()
  //   .optional()
  //   .transform((val) => val ?? "not
  // provided"),
  ww: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  pw: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  yw: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  pmwg: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  coatColor: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  size: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  weight: z.number().optional(),

  // Genetic Info
  paternalNucleus: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalType: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  breedingType: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  vaccinations: z.array(z.string()).optional(),
  racialComposition: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),

  birthCondition: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),

  // Parental Info
  damName: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  damDGR: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  damBreed: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  damBirthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  damImageUrl: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  sireDGR: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  sireName: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  sireBreed: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  sireBirthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  sireImageUrl: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),

  // Grand parental Info
  paternalGrandDamDGR: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandDamName: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandDamBreed: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandDamBirthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandDamImageUrl: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandSireDGR: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandSireName: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandSireBreed: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandSireBirthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandSireImageUrl: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandDamDGR: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandDamName: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandDamBreed: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandDamBirthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandDamImageUrl: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandSireDGR: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandSireName: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandSireBreed: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandSireBirthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandSireImageUrl: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),

  // Great-grandparental Info (8
  // great-grandparents)
  paternalGrandSireGrandSireName: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandSireGrandSireDGR: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandSireGrandSireBreed: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandSireGrandSireBirthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandSireGrandSireImageUrl: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandSireGrandDamName: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandSireGrandDamDGR: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandSireGrandDamBreed: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandSireGrandDamBirthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandSireGrandDamImageUrl: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),

  paternalGrandDamGrandSireName: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandDamGrandSireDGR: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandDamGrandSireBreed: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandDamGrandSireBirthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandDamGrandSireImageUrl: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandDamGrandDamName: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandDamGrandDamDGR: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandDamGrandDamBreed: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandDamGrandDamBirthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  paternalGrandDamGrandDamImageUrl: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),

  maternalGrandSireGrandSireName: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandSireGrandSireDGR: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandSireGrandSireBreed: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandSireGrandSireBirthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandSireGrandSireImageUrl: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandSireGrandDamName: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandSireGrandDamDGR: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandSireGrandDamBreed: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandSireGrandDamBirthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandSireGrandDamImageUrl: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),

  maternalGrandDamGrandSireName: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandDamGrandSireDGR: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandDamGrandSireBreed: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandDamGrandSireBirthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandDamGrandSireImageUrl: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandDamGrandDamName: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandDamGrandDamDGR: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandDamGrandDamBreed: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandDamGrandDamBirthDate: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  maternalGrandDamGrandDamImageUrl: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),

  // Status Info
  animalStatus: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  birthWeight: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  farmerID: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  farmID: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  url: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  imageUrls: z.array(z.string()).optional(),
  videos: z.array(videoItemSchema).optional(),

  // New fields
  farm: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  evaluation: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  assignedSupervisor: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  cattleClass: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  phases: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  slaughterInfo: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  diagnosis: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  status: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  inseminationProgram: z
    .string()
    .optional()
    .transform((val) => val ?? "not provided"),
  numberOffspring: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  indexEfficiency: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),

  // genomic and measurement fields
  length_of_rump: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  height_of_rump: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  lower_height: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  back_height: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  body_length: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  rib_depth: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  chest_perimeter: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  body_width: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  scrotal_circumference: z
    .number()
    .optional()
    .transform((val) => val ?? "not provided"),
  // mw_me: z.number ().optional ().transform (
  // val => val ?? "not provided" ), bw_de:
  // z.number ().optional ().transform ( val =>
  // val ?? "not provided" ), ww_de: z.number
  // ().optional ().transform ( val => val ??
  // "not provided" ), aw_de: z.number
  // ().optional ().transform ( val => val ??
  // "not provided" ), yw_de: z.number
  // ().optional ().transform ( val => val ??
  // "not provided" ), sc365: z.number
  // ().optional ().transform ( val => val ??
  // "not provided" ), sc450: z.number
  // ().optional ().transform ( val => val ??
  // "not provided" ), bs: z.number ().optional
  // ().transform ( val => val ?? "not
  // provided" ), prec: z.number ().optional
  // ().transform ( val => val ?? "not
  // provided" ), musc: z.number ().optional
  // ().transform ( val => val ?? "not
  // provided" ), rea: z.number ().optional
  // ().transform ( val => val ?? "not
  // provided" ), finishing: z.number
  // ().optional ().transform ( val => val ??
  // "not provided" ), mar: z.number
  // ().optional ().transform ( val => val ??
  // "not provided" ),
  mw_me_epd: z.number().optional(),
  mw_me_acc: z.number().optional(),
  mw_me_deca: z.number().optional(),
  bw_de_epd: z.number().optional(),
  bw_de_acc: z.number().optional(),
  bw_de_deca: z.number().optional(),
  ww_de_epd: z.number().optional(),
  ww_de_acc: z.number().optional(),
  ww_de_deca: z.number().optional(),
  aw_de_epd: z.number().optional(),
  aw_de_acc: z.number().optional(),
  aw_de_deca: z.number().optional(),
  yw_de_epd: z.number().optional(),
  yw_de_acc: z.number().optional(),
  yw_de_deca: z.number().optional(),
  sc365_epd: z.number().optional(),
  sc365_acc: z.number().optional(),
  sc365_deca: z.number().optional(),
  sc450_epd: z.number().optional(),
  sc450_acc: z.number().optional(),
  sc450_deca: z.number().optional(),
  bs_epd: z.number().optional(),
  bs_acc: z.number().optional(),
  bs_deca: z.number().optional(),
  prec_epd: z.number().optional(),
  prec_acc: z.number().optional(),
  prec_deca: z.number().optional(),
  musc_epd: z.number().optional(),
  musc_acc: z.number().optional(),
  musc_deca: z.number().optional(),
  rea_epd: z.number().optional(),
  rea_acc: z.number().optional(),
  rea_deca: z.number().optional(),
  finishing_epd: z.number().optional(),
  finishing_acc: z.number().optional(),
  finishing_deca: z.number().optional(),
  mar_epd: z.number().optional(),
  mar_acc: z.number().optional(),
  mar_deca: z.number().optional(),
  iabcz_epd: z.number().optional(),
  iabcz_acc: z.number().optional(),
  iabcz_deca: z.number().optional(),
});

export type FormValues = z.infer<typeof formSchema>;
